import * as _Constants from "./constants/Constants";
import * as _Interfaces from "./interfaces/SyntheticVoiceProvider";
import * as _SyntheticVoiceEngine from "./engine/SyntheticVoiceEngine";

export const Constants = _Constants;
export const Interfaces = _Interfaces;
export const SyntheticVoiceEngine = _SyntheticVoiceEngine;